import * as actionTypes from './shoppingActionType';
// import {
//   ADD_TO_CART,
//   ADJUST_QUANTITY,
//   LOAD_CURRENT_ITEM,
// } from './shoppingActionType';

const initialState = {
  products: [
    {
      id: '1',
      title: 'Asus Vivobook X515MA',
      price: 10,
      stock: 20,
      totalProduct: 20,
    },
    {
      id: '2',
      title: 'Dell E1916HV 18.5 Inch',
      price: 20,
      stock: 35,
      totalProduct: 35,
    },
    {
      id: '3',
      title: 'Canon Eos 4000D 18MP',
      price: 30,
      stock: 72,
      totalProduct: 72,
    },
  ],
  cart: [],
};
const shoppingReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ADD_TO_CART:
      const item = state.products.find(
        (product) => product.id === action.payload.id
      );
      // Check if Item is in cart already
      const inCart = state.cart.find((item) =>
        item.id === action.payload.id ? true : false
      );
      const newProducts = state.products.map((product) => {
        if (product.id === action.payload.id) {
          return {
            ...product,
            stock: product.stock - 1,
          };
        }
        return product;
      });

      return {
        ...state,
        products: newProducts,
        cart: inCart
          ? state.cart.map((item) =>
              item.id === action.payload.id
                ? { ...item, quantity: item.quantity + 1 }
                : item
            )
          : [...state.cart, { ...item, quantity: 1 }],
      };

    case actionTypes.REMOVE_FROM_CART:
      const itemm = state.products.find(
        (product) => product.id === action.payload.id
      );
      // Check if Item is in cart already
      const inCartt = state.cart.find((item) =>
        item.id === action.payload.id ? true : false
      );
      // Check
      const anewProducts = state.products.map((product) => {
        if (product.id === action.payload.id) {
          return {
            ...product,
            stock: product.stock + 1,
          };
        }
        return product;
      });

      return {
        ...state,
        products: anewProducts,
        cart: inCartt
          ? state.cart.map((item) =>
              item.id === action.payload.id
                ? { ...item, quantity: item.quantity - 1 }
                : item
            )
          : [...state.cart, { ...itemm, quantity: 1 }],
      };

    default:
      return state;
  }
};
export default shoppingReducer;
